/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';

import Button from '@material-ui/core/Button';
import { Circle } from 'components/Loading';
import classes from './Base.module.scss';

const BaseButton = (props) => {
  const { buttonColors, ...otherProps } = props;
  const {
    children,
    className,
    loading,
    nonBackground,
    variant = 'contained',
    color = buttonColors.PRIMARY,
    style,
    buttonStyle,
    isLink,
    nonUpper,
    widthAuto,
    ...other
  } = otherProps;
  const muiButtonColor =
    ['default', 'inherit', 'primary', 'secondary', 'error'].indexOf(color) >= 0 ? color : 'primary';
  return (
    <div
      className={clsx(
        className,
        classes.baseButtonWrapper,
        loading && classes.loading,
        {
          [classes.btnPrimary]: color === buttonColors.PRIMARY,
          [classes.btnError]: color === buttonColors.ERROR,
          [classes.btnBlue]: color === buttonColors.BLUE,
          [classes.isLink]: isLink,
          [classes.nonUpper]: nonUpper,
          [classes.nonBackground]: nonBackground,
          [classes.widthAuto]: widthAuto,
        }
      )}
      style={style}>
      {loading && <Circle customclass={classes.buttonLoading} />}
      <Button variant={variant} color={muiButtonColor} style={buttonStyle} {...other}>
        {children}
      </Button>
    </div>
  );
};

export default BaseButton;
